<template>
  <v-responsive>
    <fieldset>
      <legend>{{ label }}</legend>
      <div class="wrapper">
        <div
          v-for="(item, index) in items"
          v-bind:key="index"
          class="inputs-container"
        >
          <label>
            <input
              class="input"
              type="checkbox"
              :name="trans(item.name)"
              :value="item.id"
              :id="item.id"
              v-model="selected"
            />
            {{ trans(item.name) }}
          </label>
        </div>
      </div>
    </fieldset>
  </v-responsive>
</template>

<script>
export default {
  props: {
    value: { type: Array, required: true },
    label: { type: String, required: true },
    items: { type: Array, required: true },
  },
  data() {
    return {
      selected: [],
      active: false,
    };
  },
  created() {
    setTimeout(() => this.active = true, 2000);
  },
  watch: {
    value: function (newVal) {
      this.selected = newVal;
    },
    selected: function () {
      if (this.active) {
        this.$emit("input", this.selected);
        this.$emit("update", this.selected);
      }
    },
  },
};
</script>

<style scoped>
fieldset {
  border: 1.4px solid grey;
  border-radius: 10px;
  overflow-y: scroll;
  scroll-behavior: smooth;
}

legend {
  font-size: 0.9rem;
  width: fit-content;
  margin-bottom: 1px;
  margin-left: 14px;
  padding: 0 3px 0 3px;
}

.wrapper {
  max-height: 300px;
}

.inputs-container {
  width: 100%;
  cursor: pointer;
  padding-left: 10px;
}

.inputs-container:hover {
  background-color: #dadada;
}

label {
  width: 100%;
  cursor: pointer;
  margin: 4px 0 4px 0;
}

.input {
  height: 20px;
  width: 20px;
  margin: 7px 15px 7px 2px;
  cursor: pointer;
  vertical-align: -4px;
}

/*---- Start scroll bar style -----*/
/* width */
::-webkit-scrollbar {
  width: 6px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/***----- Ends  scroll bar style ----****/
</style>
